import {_CRUD} from "./_Action";
import {_CALL_API} from "../../middleware/api";
import {RootState} from "../reducer";
import {route} from "../../../conf/routes";

export const NEWSLETTER = 'newsletter';
const _NEWSLETTER = _CRUD(NEWSLETTER);

export const sendNewsletterInfos = (values) => (dispatch, getState: () => RootState) => {
  const enterpriseId = getState().accountInfo.enterpriseSelected.id
  return dispatch({
    [_CALL_API]: {
      types: [_NEWSLETTER.UPDATE.REQUEST, _NEWSLETTER.UPDATE.SUCCESS, _NEWSLETTER.UPDATE.FAILURE],
      route: route.newsletter.send(values, enterpriseId)
    }
  })
};



// WEBPACK FOOTER //
// ./src/core/redux/action/newsletterAction.ts